import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['scrollOutText', 'showMoreLink'];

  showMoreLinkTarget: HTMLElement;

  scrollOutTextTarget: HTMLElement;

  onClickSeeDetailLink(e: Event) {
    e.preventDefault();
    this.scrollOutTextTarget.classList.add('expanded');
    this.showMoreLinkTarget.remove();
  }
}
